import { fontSize, fontWeight, height, maxHeight, maxWidth } from "@mui/system";

import { fonts, gutterX, radius } from "../shared/ticketLayout";

const styles = (theme) => ({
  containerPaper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: radius.panel,
    overflow: "hidden",
    // O container da lista é flex column com altura máxima. Sem isto os
    // cartões herdam flex-shrink: 1 e são comprimidos quando a soma passa do
    // limite — combinado com o overflow: hidden acima, o fim do cartão (a
    // descrição) some. Com flexShrink: 0 o cartão mantém a altura natural e
    // quem rola é a lista.
    flexShrink: 0,
    backgroundColor: theme.palette.background.wallpaper,
  },
  // Cabeçalho do cartão de OS: identificação à esquerda, menu à direita.
  // O botão do menu era posicionado de forma absoluta sobre o conteúdo, o que
  // no celular cobria o primeiro campo da grade.
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    px: { xs: 1.5, sm: 2 },
    py: 1.25,
    minWidth: 0,
  },
  cardHeaderIdentificacao: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    flexWrap: "wrap",
    minWidth: 0,
  },
  cardNumeroOs: {
    fontSize: fonts.sectionTitle,
    fontWeight: 700,
    letterSpacing: "-0.01em",
  },
  cardMenuButton: {
    flexShrink: 0,
  },
  cardSecao: {
    px: { xs: 1.5, sm: 2 },
    py: 1.5,
  },
  cardSecaoHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    mb: 0.5,
  },
  cardSecaoTitulo: {
    fontSize: fonts.chip,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  textoVazio: {
    fontSize: fonts.body,
    fontStyle: "italic",
    color: theme.palette.text.disabled,
    p: 1,
  },
  containerTecnicos: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    mt: 0.5,
  },
  avatarTecnico: {
    width: 32,
    height: 32,
  },
  nomeTecnico: {
    fontSize: fonts.body,
  },
  containerHeader: {
    display: "flex",
    flexDirection: "column",
    padding: 2,
    gap: 1,
  },
  paperAnexo: {
    flexShrink: 0,
    width: 80,
    height: 80,
    overflow: "hidden",
    borderRadius: 1,
    cursor: "pointer",
  },
  containerActions: {
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: "flex-end",
    marginTop: 2,
    px: gutterX,
    gap: 1.5,
  },
  containerPaperModal: {
    width: "100%",
    borderRadius: radius.panel,
    padding: { xs: 1, sm: 2 },
    overflowY: "auto",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1,
    flexWrap: "wrap",
  },
  boxBodyModal: { px: gutterX },
  containerBodyModal: {
    overflowY: "auto",
  },
  // Lista de ordens de serviço. A altura era 600px fixos, escrita inline: alta
  // demais para um celular e baixa demais para uma tela grande.
  listaOs: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: { xs: 1, sm: 2 },
    overflowY: "auto",
    maxHeight: { xs: "none", sm: "60vh", lg: "65vh" },
  },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1,
    minHeight: "50px",
    py: 1,
    px: gutterX,
  },
  containerPaperMensagem: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  containerAvatar: {
    width: "100%",
    display: "flex",
    gap: 2,
  },
  // Usado no histórico da OS. A chave não existia — o sx resolvia para
  // undefined e o nome do usuário saía sem destaque nenhum.
  nameUser: {
    fontSize: fonts.body,
    fontWeight: 600,
    lineHeight: 1.4,
  },
  nameUserViewed: {
    fontSize: fonts.body,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "200px",
  },
  textMensagem: {
    fontSize: fonts.reading,
    lineHeight: 1.6,
    whiteSpace: "pre-line",
    wordBreak: "break-word",
  },
  boxHistorico: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "90%",
    maxHeight: 550,
    overflow: "auto",
    p: 1,
  },
  paperHistorico: {
    p: { xs: 1.25, sm: 2 },
    mx: gutterX,
    borderRadius: radius.panel,
  },
  containerHistorico: {
    p: 2,
    display: "flex",
    gap: 1,
  },
  bodyMensagem: { padding: 2, display: "flex", gap: 2, alignItems: "center" },
  containerData: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerDataTenico: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    padding: 2,
  },
  titleData: { fontWeight: 600, fontSize: fonts.label },
  boxData: { display: "flex", flexDirection: "column", padding: 2 },
  boxHeader: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  boxDataTecnico: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    padding: 0.5,
  },
  containerAnexos: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    py: 1,
    alignItems: "center",
    justifyContent: "flex-start",
  },
  boxImg: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    display: "block",
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
  },
  boxWithoutImg: {
    width: "40px",
    height: "40px",

    display: "block",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    fontWeight: 600,
    color: theme.palette.white.main,
    fontSize: fonts.chip,
    textTransform: "capitalize",
    maxWidth: "100%",
    height: "22px",
    borderRadius: radius.chip,
  },
});

export default styles;
